<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">中云巨量(青岛)智慧数据科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：青岛市北区浪潮大数据产业园</span>
      <span>Tel：13465329001</span>
    </p>
    <p class="email_wx">
      <span>邮箱：zhongyunshuju0532@126.com</span>
      <span>微信号：leemonth</span>
    </p>
    <p class="copy">Copyright &copy; 2020 - {{ new Date().getFullYear() }} 中云巨量(青岛)智慧数据科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(53, 64, 84, 1);;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 95px;
  margin: 50px auto 20px;
}
.logo img{
  width: 95px;
  /* height: 45px; */
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue